export default {
    data: [],
    selectedCustomerApplicationId: null
}